import React from 'react';

const VoucherVerifyErrorIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M9 0C13.95 0 18 4.05 18 9C18 13.9875 13.95 18 9 18C4.0125 18 0 13.9875 0 9C0 4.05 4.0125 0 9 0ZM12 10.8L10.2375 9L12 7.2375C12.375 6.9 12.375 6.3375 12 6C11.6625 5.625 11.1 5.625 10.7625 6L9 7.7625L7.2 6C6.8625 5.625 6.3 5.625 5.9625 6C5.5875 6.3375 5.5875 6.9 5.9625 7.2375L7.725 9L5.9625 10.8C5.5875 11.1375 5.5875 11.7 5.9625 12.0375C6.3 12.4125 6.8625 12.4125 7.2 12.0375L9 10.275L10.7625 12.0375C11.1 12.4125 11.6625 12.4125 12 12.0375C12.375 11.7 12.375 11.1375 12 10.8Z"
      fill="#FF0000"
    />
  </svg>
);

export default VoucherVerifyErrorIcon;
